'use strict';

import './slider.component.scss';
import sliderTemplate from './slider.component.html';
import './slider.semantic.scss';
import './slider.semantic.js';

export default angular
  .module('maestro.directives.components.slider', [])
  .directive('smSlider', () => {
    return {
      restrict: 'E',
      template: sliderTemplate,
      scope: {
        ngModel: '=', // Number bind to slider, number
        min: '=',
        max: '=',
        step: '=',
        disabled: '='
      },
      controller: ($scope, $element, $attrs) => {

        reInitSlider();

        $scope.$on('$destroy', () => {
          // TODO
        });

        $scope.$watch('ngModel', (newValue, oldValue) => {
          if (newValue == oldValue) {
            return;
          }
          setExternalSliderValue(newValue);
        });

        $scope.$watchGroup(['min', 'max', 'step'], () => {
          reInitSlider();
        });

        function setExternalSliderValue(newValue) {
          $($element).find('.range').range('set value', parseAsNumberOrUndefined(newValue));
        }

        function reInitSlider() {
          let min = parseAsNumberOrUndefined($scope.min);
          let max = parseAsNumberOrUndefined($scope.max);
          let step = parseAsNumberOrUndefined($scope.step);
          let currentValue = parseAsNumberOrUndefined($scope.ngModel);

          $($element).find('.range').range({
            min: min,
            max: max,
            step: step,
            start: currentValue,
            onChange: (value, meta) => {
              if (meta?.triggeredByUser) {
                $scope.$applyAsync(() => {
                  $scope.ngModel = value;
                });
              }
            }
          });
        }

        /**
         * Parse string to floating-point number, or return undefined if can't
         * @param {string|number|undefined|NaN|null} input
         * @return {undefined|number}
         */
        function parseAsNumberOrUndefined(input) {
          let val = parseFloat(input);
          return (val == null || Number.isNaN(val) || !Number.isFinite(val)) ? undefined : val;
        }
      }
    };
  })
  .name;
